<div class="container">
	<button
		mat-raised-button
		color="primary"
		class="my-3 py-1 organization-bank-accounts-add"
		(click)="openBankAccountDialog(OrganizationBankAccountMode.ADD)"
	>
		<i class="fa-solid fa-credit-card"></i> Dodaj konto bankowe
	</button>
	<button mat-raised-button color="primary" class="my-3 py-1 ms-3" (click)="openMassBankAccountDialog()">
		<i class="fa-solid fa-credit-card"></i> Dodaj wiele kont bankowych
	</button>
	<mat-table #bankAccountsTable [dataSource]="dataTableBankAccounts" cdkDropList cdkDropListDisabled="true">
		<ng-container matColumnDef="index">
			<mat-header-cell *matHeaderCellDef> LP</mat-header-cell>
			<mat-cell *matCellDef="let element; let i = index">
				{{ i + 1 }}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="isActive">
			<mat-header-cell *matHeaderCellDef> Czy aktywne?</mat-header-cell>
			<mat-cell *matCellDef="let element">
				<i
					class="fa-solid"
					[ngClass]="{
						'fa-circle-check green': element.isActive,
						'fa-circle-xmark red': !element.isActive,
					}"
				></i>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="currency">
			<mat-header-cell *matHeaderCellDef> Waluta</mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{ element.currency?.name }}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="number">
			<mat-header-cell *matHeaderCellDef> Numer konta</mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{ element.number | bankAccountFormat }}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="swift">
			<mat-header-cell *matHeaderCellDef> SWIFT</mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{ element.swift }}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="fastAlior">
			<mat-header-cell *matHeaderCellDef> Fast Alior</mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{ element.fastAlior | yesNo }}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="mainAccount">
			<mat-header-cell *matHeaderCellDef> Konto główne</mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{ element.mainAccount | yesNo }}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="edit">
			<mat-header-cell *matHeaderCellDef></mat-header-cell>
			<mat-cell *matCellDef="let element">
				<button
					mat-raised-button
					color="primary"
					class="organization-bank-accounts-edit"
					(click)="openBankAccountDialog(OrganizationBankAccountMode.EDIT, element)"
				>
					Edytuj
				</button>
			</mat-cell>
		</ng-container>
		<mat-header-row *matHeaderRowDef="bankAccountsColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: bankAccountsColumns" cdkDrag></mat-row>
	</mat-table>
</div>
